import { Form } from '@rocketseat/unform';
import Button from 'atoms/Button/button';
import WhiteSideBar from 'components/community/editPublicAirmeet/Sessions/WhiteSideBar';
import { Box, FlexDiv } from 'components/molecules/utils/basicComponents';
import { getCustomScroll } from 'components/molecules/utils/customStyles';
import { alpha } from 'foundations/theme';
import { Typography } from 'foundations/typography';
import React from 'react';
import styled from 'styled-components';
import { cdnImage } from 'utils/core';
import EventDetails from './EventDetails';
import { EndDate } from './FormFields/EndDate';
import { EndTime } from './FormFields/EndTime';
import EventEntryField from './FormFields/EventEntryField';
import { Name } from './FormFields/Name';
import { Organiser } from './FormFields/Organiser';
import { SocialLounge } from './FormFields/socialLounge';
import { StartDate } from './FormFields/StartDate';
import { StartTime } from './FormFields/StartTime';
import { TimeZone } from './FormFields/TimeZone';
import DateTime from './screens/DateTime';
import SocialLoungeTables from './screens/SocialLoungeTables';
import TimeZoneScreen from './screens/TimeZoneScreen';

const DATE_FORMAT = 'MMM d, yyyy';

export default function FormContent({
    eventCreated,
    showSidemenu,
    editMode,
    handleEditSubmit,
    handleSubmit,
    formData,
    changeFormData,
    nameRef,
    mode,
    errors,
    onboardingInitiation,
    pageMode,
    setTypeDateTime,
    setShowSideMenu,
    getMinDate,
    getMinTime,
    onStateChanged,
    typeDateTime,
    selectedOption,
    handleNameError,
    onValueChange,
    handleNumberInput,
    handleIncrement,
    handleDecrement,
    setActiveOption,
    loading,
    isFormValid,
    hideRightSection,
    modeImage,
    modeText,
    isUGCEnabled,
    submitBtnId,
    logOnboardingAnalyticsEvent,
    analyticsEventType,
    timeZone,
    isFullScreen,
    isCreateAirmeetV3,
    airmeetId,
    eventEntryValue,
    setEventEntryValue,
    domainList,
    setDomainList,
}) {
    return (
        <FlexDiv width={'100%'}>
            {!eventCreated && (
                <StyledRowFlexDiv
                    isFullScreen={isFullScreen}
                    mt={isCreateAirmeetV3 && isFullScreen ? '28px' : '0px'}
                    isCreateAirmeetV3={isCreateAirmeetV3}
                >
                    <LeftSection
                        showSidemenu={showSidemenu !== ''}
                        verticalWidth={'12px'}
                        pageMode={pageMode}
                    >
                        {isCreateAirmeetV3 && (
                            <Typography
                                variant={'subtitle2-bold'}
                                color={'ambience.0'}
                                mb={'24px'}
                            >
                                Basic Information
                            </Typography>
                        )}
                        <Form
                            onSubmit={
                                editMode ? handleEditSubmit : handleSubmit
                            }
                            initialData={
                                pageMode && onboardingInitiation
                                    ? { initDate: formData?.initDate }
                                    : formData
                            }
                            onChange={changeFormData}
                            noValidate
                        >
                            <Box className='form-content'>
                                <Box
                                    className='form-field-outer'
                                    mb={2}
                                    ref={nameRef}
                                    width={pageMode ? '45%' : 'auto'}
                                >
                                    <Name
                                        formData={formData}
                                        mode={mode}
                                        errors={errors}
                                        newOnBoardingFlow={onboardingInitiation}
                                        pageMode={pageMode}
                                        onEventNameFocus={() => {
                                            logOnboardingAnalyticsEvent(
                                                analyticsEventType.changedEventName
                                            );
                                        }}
                                        isCreateAirmeetV3={isCreateAirmeetV3}
                                    />
                                </Box>
                                {pageMode && (
                                    <Box mb={3}>
                                        <FlexDiv
                                            justifyContent={'space-between'}
                                            mb={3}
                                            width={'45%'}
                                        >
                                            <StartDate
                                                formData={formData}
                                                setTypeDateTime={
                                                    setTypeDateTime
                                                }
                                                setShowSideMenu={
                                                    setShowSideMenu
                                                }
                                                getMinDate={getMinDate}
                                                newOnBoardingFlow={
                                                    onboardingInitiation
                                                }
                                                pageMode={pageMode}
                                                onStartDateFocus={() => {
                                                    logOnboardingAnalyticsEvent(
                                                        analyticsEventType.changedStartDate
                                                    );
                                                }}
                                                isCreateAirmeetV3={
                                                    isCreateAirmeetV3
                                                }
                                            />
                                            <StartTime
                                                formData={formData}
                                                setShowSideMenu={
                                                    setShowSideMenu
                                                }
                                                getMinTime={getMinTime}
                                                onStateChanged={onStateChanged}
                                                disabled
                                                showSidemenu={showSidemenu}
                                                newOnBoardingFlow={
                                                    onboardingInitiation
                                                }
                                                pageMode={pageMode}
                                                onStartTimeFocus={() => {
                                                    logOnboardingAnalyticsEvent(
                                                        analyticsEventType.changedStartTime
                                                    );
                                                }}
                                                isCreateAirmeetV3={
                                                    isCreateAirmeetV3
                                                }
                                            />
                                        </FlexDiv>
                                    </Box>
                                )}
                                {onboardingInitiation && (
                                    <>
                                        <Box
                                            className='form-field-outer'
                                            mb={2}
                                            width={pageMode ? '45%' : 'auto'}
                                        >
                                            <Organiser
                                                formData={formData}
                                                mode={mode}
                                                errors={errors}
                                                newOnBoardingFlow={
                                                    onboardingInitiation
                                                }
                                                pageMode={pageMode}
                                                onOrgNameFocus={() => {
                                                    logOnboardingAnalyticsEvent(
                                                        analyticsEventType.changedOrgName
                                                    );
                                                }}
                                            />
                                        </Box>
                                        {pageMode && (
                                            <Box>
                                                <CreateEventNoteText
                                                    variant={'subtext2'}
                                                    color={'ambience.12'}
                                                >
                                                    Don’t fret! You can change
                                                    these details later.
                                                </CreateEventNoteText>
                                            </Box>
                                        )}
                                    </>
                                )}
                                {!onboardingInitiation && (
                                    <Box>
                                        <Box mb={3}>
                                            <FlexDiv
                                                justifyContent={'space-between'}
                                                mb={3}
                                                className={
                                                    isCreateAirmeetV3
                                                        ? 'date-fields-wrapper'
                                                        : ''
                                                }
                                            >
                                                <StartDate
                                                    formData={formData}
                                                    setTypeDateTime={
                                                        setTypeDateTime
                                                    }
                                                    setShowSideMenu={
                                                        setShowSideMenu
                                                    }
                                                    getMinDate={getMinDate}
                                                    newOnBoardingFlow={
                                                        onboardingInitiation
                                                    }
                                                    pageMode={pageMode}
                                                    wrapperStyles={
                                                        isCreateAirmeetV3
                                                            ? {
                                                                  maxWidth:
                                                                      '100%',
                                                                  marginRight:
                                                                      '32px',
                                                              }
                                                            : {}
                                                    }
                                                    isCreateAirmeetV3={
                                                        isCreateAirmeetV3
                                                    }
                                                />
                                                <StartTime
                                                    formData={formData}
                                                    setShowSideMenu={
                                                        setShowSideMenu
                                                    }
                                                    getMinTime={getMinTime}
                                                    onStateChanged={
                                                        onStateChanged
                                                    }
                                                    disabled
                                                    showSidemenu={showSidemenu}
                                                    newOnBoardingFlow={
                                                        onboardingInitiation
                                                    }
                                                    pageMode={pageMode}
                                                    isCreateAirmeetV3={
                                                        isCreateAirmeetV3
                                                    }
                                                />
                                            </FlexDiv>
                                            <FlexDiv
                                                justifyContent={'space-between'}
                                                mb={3}
                                                className={
                                                    isCreateAirmeetV3
                                                        ? 'date-fields-wrapper'
                                                        : ''
                                                }
                                            >
                                                <EndDate
                                                    formData={formData}
                                                    setTypeDateTime={
                                                        setTypeDateTime
                                                    }
                                                    setShowSideMenu={
                                                        setShowSideMenu
                                                    }
                                                    getMinDate={getMinDate}
                                                    newOnBoardingFlow={
                                                        onboardingInitiation
                                                    }
                                                    wrapperStyles={
                                                        isCreateAirmeetV3
                                                            ? {
                                                                  maxWidth:
                                                                      '100%',
                                                                  marginRight:
                                                                      '32px',
                                                              }
                                                            : {}
                                                    }
                                                    isCreateAirmeetV3={
                                                        isCreateAirmeetV3
                                                    }
                                                />
                                                <EndTime
                                                    formData={formData}
                                                    setShowSideMenu={
                                                        setShowSideMenu
                                                    }
                                                    getMinTime={getMinTime}
                                                    onStateChanged={
                                                        onStateChanged
                                                    }
                                                    typeDateTime={typeDateTime}
                                                    disabled
                                                    showSidemenu={showSidemenu}
                                                    newOnBoardingFlow={
                                                        onboardingInitiation
                                                    }
                                                    isCreateAirmeetV3={
                                                        isCreateAirmeetV3
                                                    }
                                                />
                                            </FlexDiv>
                                            <TimeZoneWrapper
                                                isTextOly={isCreateAirmeetV3}
                                            >
                                                {isCreateAirmeetV3 &&
                                                    'Timezone - '}
                                                <TimeZone
                                                    formData={formData}
                                                    timeZone={timeZone}
                                                    showSidemenu={showSidemenu}
                                                    setShowSideMenu={
                                                        setShowSideMenu
                                                    }
                                                    selectedOption={
                                                        selectedOption
                                                    }
                                                    newOnBoardingFlow={
                                                        onboardingInitiation
                                                    }
                                                />
                                                {isCreateAirmeetV3 && (
                                                    <Button
                                                        onClick={() =>
                                                            setShowSideMenu(
                                                                'timezone'
                                                            )
                                                        }
                                                        variant={'link'}
                                                        color={
                                                            'accentPrimary.0'
                                                        }
                                                        ml={'12px'}
                                                    >
                                                        Change
                                                    </Button>
                                                )}
                                            </TimeZoneWrapper>
                                            <EventEntryField
                                                eventEntryValue={
                                                    eventEntryValue
                                                }
                                                setEventEntryValue={
                                                    setEventEntryValue
                                                }
                                                domainList={domainList}
                                                setDomainList={setDomainList}
                                                editMode={editMode}
                                                airmeetId={airmeetId}
                                            />
                                        </Box>
                                    </Box>
                                )}
                                <Box mb={3} id={'data-time-error'}>
                                    <Typography
                                        color={'semantic.1'}
                                        variant={'caption'}
                                    >
                                        {errors.initDate || errors.initTime}
                                    </Typography>
                                </Box>
                                {!onboardingInitiation && !isUGCEnabled && (
                                    <SocialLounge
                                        formData={formData}
                                        showSidemenu={showSidemenu}
                                        setShowSideMenu={setShowSideMenu}
                                        error={errors.tableCount}
                                        isCreateAirmeetV3={isCreateAirmeetV3}
                                    />
                                )}
                                {showSidemenu && (
                                    <WhiteSideBar
                                        // onClose={() => {
                                        //     setShowSideMenu('');
                                        //     handleNameError();
                                        // }}
                                        newOnBoardingFlow={onboardingInitiation}
                                        pageMode={pageMode}
                                    >
                                        <FlexDiv
                                            flexDirection={'column'}
                                            width={'100%'}
                                        >
                                            {showSidemenu === 'social_lounge' &&
                                                !onboardingInitiation && (
                                                    <SocialLoungeTables
                                                        onClose={() => {
                                                            setShowSideMenu('');
                                                            handleNameError();
                                                        }}
                                                        onValueChange={
                                                            onValueChange
                                                        }
                                                        isSocialTablesEnabled={
                                                            formData.hasVirtualTables
                                                        }
                                                        state={
                                                            errors.tableCount
                                                                ? 'error'
                                                                : 'normal'
                                                        }
                                                        errorMsg={
                                                            errors.tableCount
                                                        }
                                                        value={
                                                            formData.tableCount
                                                        }
                                                        handleNumberInput={
                                                            handleNumberInput
                                                        }
                                                        handleIncrement={
                                                            handleIncrement
                                                        }
                                                        handleDecrement={
                                                            handleDecrement
                                                        }
                                                    />
                                                )}
                                            {showSidemenu === 'start_time' && (
                                                <StartTime
                                                    formData={formData}
                                                    setShowSideMenu={
                                                        setShowSideMenu
                                                    }
                                                    getMinTime={getMinTime}
                                                    onStateChanged={
                                                        onStateChanged
                                                    }
                                                    inline
                                                    showSidemenu={showSidemenu}
                                                    onClose={() => {
                                                        setShowSideMenu('');
                                                        handleNameError();
                                                    }}
                                                    newOnBoardingFlowSideMenu={
                                                        onboardingInitiation
                                                    }
                                                    pageMode={pageMode}
                                                    isCreateAirmeetV3={
                                                        isCreateAirmeetV3
                                                    }
                                                />
                                            )}
                                            {showSidemenu === 'end_time' && (
                                                <EndTime
                                                    formData={formData}
                                                    setShowSideMenu={
                                                        setShowSideMenu
                                                    }
                                                    getMinTime={getMinTime}
                                                    onStateChanged={
                                                        onStateChanged
                                                    }
                                                    typeDateTime={typeDateTime}
                                                    inline
                                                    showSidemenu={showSidemenu}
                                                    onClose={() => {
                                                        setShowSideMenu('');
                                                        handleNameError();
                                                    }}
                                                    newOnBoardingFlowSideMenu={
                                                        onboardingInitiation
                                                    }
                                                    isCreateAirmeetV3={
                                                        isCreateAirmeetV3
                                                    }
                                                />
                                            )}
                                            {[
                                                'starting_on',
                                                'ending_on',
                                            ].includes(showSidemenu) && (
                                                <DateTime
                                                    name={
                                                        showSidemenu ===
                                                        'starting_on'
                                                            ? 'initDate'
                                                            : 'finalDate'
                                                    }
                                                    dateFormat={DATE_FORMAT}
                                                    onChange={onStateChanged(
                                                        showSidemenu ===
                                                            'starting_on'
                                                            ? 'initDate'
                                                            : 'finalDate'
                                                    )}
                                                    placeholder={'Select Date'}
                                                    defaultDate={
                                                        formData[
                                                            showSidemenu ===
                                                            'starting_on'
                                                                ? 'initDate'
                                                                : 'finalDate'
                                                        ]
                                                    }
                                                    title={
                                                        showSidemenu ===
                                                        'starting_on'
                                                            ? 'Starting On'
                                                            : 'Ending On'
                                                    }
                                                    typeDateTime={typeDateTime}
                                                    showSidemenu={showSidemenu}
                                                    setShowSideMenu={
                                                        setShowSideMenu
                                                    }
                                                    onClose={() => {
                                                        setShowSideMenu('');
                                                        handleNameError();
                                                    }}
                                                    newOnBoardingFlow={
                                                        onboardingInitiation
                                                    }
                                                    getMinDate={getMinDate}
                                                    pageMode={pageMode}
                                                />
                                            )}

                                            {showSidemenu === 'timezone' && (
                                                <TimeZoneScreen
                                                    // defaultValue={formData.timeZone}
                                                    defaultValue={timeZone}
                                                    onChange={onStateChanged(
                                                        'timeZone'
                                                    )}
                                                    activeOption={
                                                        setActiveOption
                                                    }
                                                    onClose={() => {
                                                        setShowSideMenu('');
                                                        handleNameError();
                                                    }}
                                                    newOnBoardingFlow={
                                                        onboardingInitiation
                                                    }
                                                />
                                            )}
                                        </FlexDiv>
                                    </WhiteSideBar>
                                )}
                            </Box>
                            <Footer alignItems={'center'} pageMode={pageMode}>
                                <Box
                                    display={'flex'}
                                    alignItems={'center'}
                                    width={'100%'}
                                >
                                    <StyledButton
                                        type='submit'
                                        id={submitBtnId || 'create-event-btn'}
                                        maxWidth={'144px'}
                                        variant={'primary'}
                                        loading={loading}
                                        disabled={
                                            onboardingInitiation &&
                                            !isFormValid()
                                        }
                                        isCreateAirmeetV3={isCreateAirmeetV3}
                                    >
                                        {editMode
                                            ? isCreateAirmeetV3
                                                ? 'Save'
                                                : 'Update Event'
                                            : 'Create Event'}
                                    </StyledButton>
                                    {!pageMode && !isCreateAirmeetV3 && (
                                        <Box>
                                            <Typography
                                                variant={'subtext2'}
                                                ml={3}
                                                color={'ambience.12'}
                                            >
                                                You can always change these
                                                details later
                                            </Typography>
                                        </Box>
                                    )}
                                </Box>
                            </Footer>
                        </Form>
                    </LeftSection>
                    {!hideRightSection && (
                        <RightSection
                            alignItems={'center'}
                            justifyContent={'center'}
                            flexDirection={'column'}
                            verticalWidth={'12px'}
                        >
                            <FlexDiv
                                alignItems={'center'}
                                justifyContent={'center'}
                                mb={4}
                            >
                                <Img
                                    src={cdnImage(`images/${modeImage}.svg`)}
                                />
                            </FlexDiv>
                            <Box>
                                <Typography
                                    variant={'body2'}
                                    color={'ambience.4'}
                                >
                                    {modeText}
                                </Typography>
                            </Box>
                        </RightSection>
                    )}

                    {isCreateAirmeetV3 && (
                        <RightSection
                            verticalWidth={'12px'}
                            pl={!isFullScreen ? '32px' : '0px'}
                        >
                            <Box width={'100%'}>
                                <Typography
                                    variant={'subtitle2-bold'}
                                    color={'ambience.0'}
                                    mb={'16px'}
                                >
                                    Additional Information
                                </Typography>
                                <EventDetails
                                    formData={formData}
                                    onValueChange={onValueChange}
                                    errors={errors}
                                    pageMode={pageMode}
                                    mode={mode}
                                    eventEntryValue={eventEntryValue}
                                    setEventEntryValue={setEventEntryValue}
                                    domainList={domainList}
                                    setDomainList={setDomainList}
                                />
                            </Box>
                        </RightSection>
                    )}
                </StyledRowFlexDiv>
            )}
        </FlexDiv>
    );
}

const StyledButton = styled(Button)`
    width: 100%;
    &:focus {
        outline: none !important;
    }
    ${({ isCreateAirmeetV3, theme }) =>
        isCreateAirmeetV3 &&
        `
        background: ${theme.colors.accentPrimary[0]}
    `}
`;

const LeftSection = styled(Box)`
    height: 100%;
    max-height: calc(100vh - 190px);
    overflow-y: ${({ showSidemenu }) => (showSidemenu ? 'hidden' : 'auto')};
    overflow-x: hidden;
    padding-left: 0;
    padding-right: 32px;
    width: 100%;
    max-width: ${({ pageMode }) => (pageMode ? 'auto' : '558px')};
    @media only screen and (max-width: 1059px) {
        min-width: unset;
    }
    @media only screen and (max-width: 929px) {
        padding-right: 0 !important;
        padding-bottom: 32px;
    }
    ${({ theme, verticalWidth, alwaysShowScroll = true }) =>
        getCustomScroll({ theme, verticalWidth, alwaysShowScroll })};
`;
const RightSection = styled(FlexDiv)`
    width: 100%;
    max-width: 439px;
    height: 100%;
    max-height: calc(100vh - 190px);
    padding-right: 12px;
    overflow-y: auto;
    overflow-x: hidden;
    border-left: 1px solid ${({ theme }) => theme.colors.ambience[20]};
    @media only screen and (max-width: 929px) {
        padding-left: 0 !important;
        padding-top: 32px;
        border-left: 0px;
        border-top: 1px solid ${({ theme }) => theme.colors.ambience[19]};
    }
    ${({ theme, verticalWidth }) => getCustomScroll({ theme, verticalWidth })};
`;
const Img = styled.img`
    height: 155px;
    width: 263px;
    max-width: 100%;
`;

const Footer = styled(FlexDiv)`
    max-width: 1062px;
    width: 100%;
    position: fixed;
    bottom: 30px;
    ${({ pageMode }) =>
        !pageMode &&
        `
        bottom: 0 !important;
        right: 0 !important;
        padding: 12px 32px 32px 32px !important;
    `}
`;

const CreateEventNoteText = styled(Typography)`
    font-size: 15px;
`;

const TimeZoneWrapper = styled(Box)`
    ${({ isTextOly, theme }) =>
        isTextOly &&
        `
        font-size: 14px;
        line-height: 18px;
        color: ${theme.colors.ambience[1]};
        display: flex;
        justify-content: flex-end;
        align-items: center;
        font-family: ${theme.fonts.book};

        > div {
            margin-left: 5px;
            label {
                display: none;
            }
        }
        #timeZonePicker {
            padding: 0;
            background: transparent;
            margin: 0;
            min-height: 1px;
            pointer-events: none;

            p {
                font-size: 14px;
                line-height: 18px;
                color: ${theme.colors.ambience[1]};
                font-family: ${theme.fonts.book};
                margin: 0;

                &:nth-child(2){
                    &:before {
                        content: " ,";
                        display: inline-flex;
                        margin-right: 5px;
                    }
                }
            }
            &:before {
                right: -130px;
            }
        }
    `}
`;

const StyledRowFlexDiv = styled(FlexDiv)`
    width: 100%;
    @media only screen and (max-width: 929px) {
        flex-wrap: wrap;
    }

    .date-fields-wrapper {
        > div {
            max-width: 50%;
            &:first-child {
                margin-right: 32px;
            }
            @media (max-width: 520px) {
                max-width: 100%;
                margin: 0;
                &:first-child {
                    margin-right: 0;
                    margin-bottom: 24px;
                }
            }
        }
        @media (max-width: 520px) {
            flex-wrap: wrap;
        }
    }

    ${({ isFullScreen, theme }) =>
        isFullScreen &&
        `
        flex-wrap: wrap;
        padding-bottom: 140px;

        ${LeftSection}{
            overflow: visible;
            max-height: inherit;
            padding-left: 0;
            padding-right: 0;
            width: 100%;
            max-width: 100%;
            padding-bottom: 0;
            height: auto;
            
            @media(min-width: 992px){
                padding-right: 25px;
                width: 100%;
                max-width: 50%;
            }

            @media(min-width: 1280px){
                max-width: 570px;
                padding-right: 50px;
            }
        }
        ${RightSection}{
            width: 100%;
            max-width: 100%;
            padding-left: 0;
            padding-right: 0;
            border: 0;
            overflow: visible;
            max-height: inherit;
            display: block;
            padding-bottom: 0;
            height: auto;

            @media(min-width: 992px){
                padding-left: 25px;
                width: 100%;
                max-width: 50%;
            }

            @media(min-width: 1280px){
                max-width: 464px;
                padding-left: 50px;
            }
        }
        ${Footer}{
            bottom: 0;
            left: 0;
            right: 0;
            padding: 24px 0 !important;
            box-shadow: 0px 1px 8px ${alpha(theme.colors.black, 0.08)};
            background: ${theme.colors.ambience[23]};
            max-width: 100%;
            border-top: 1px solid ${theme.colors.ambience[20]};

            > div {
                max-width: 1160px;
                width: 100%;
                padding-left: 32px;
                padding-right: 32px;
                margin-left: auto;
                margin-right: auto;

                @media (min-width: 1280px) {
                    max-width: 1204px;
                }
            }
        }
        ${StyledButton}{
            max-width: 528px;
            width: 100%;
        }
        .form-field.active, #timeZonePicker.active {
            &:before {
                display: none;
            }
        }
    `}
`;
